package com.kinoshazam.di

import com.kinoshazam.data.JsStorageFactory
import org.koin.core.module.Module
import org.koin.core.qualifier.named
import org.koin.dsl.module

actual fun storageModule(): Module = module {
    single(named(STORAGE_COMMON)) { JsStorageFactory().common() }
    single(named(STORAGE_USER)) { JsStorageFactory().user() }
    single(named(STORAGE_SECURE)) { JsStorageFactory().secure() }
}
